<section class="try-area" *ngIf="showTryArea">

    <div class="container text-center py-5">
        <div class="h2 mb-4"><b>Gelişmiş Entegratör ile İşlerinizi Kolaylaştırın ve Hızlandırın</b></div>
        <div class="h5">Entegratör hizmetimizi 14 gün boyunca ücretsiz deneyerek, tüm entegrasyon özelliklerini keşfedin
            ve iş süreçlerinizi nasıl hızlandırabileceğinizi görün.</div>

        <div class="py-3">
            <a href="https://panel.entegi.com/account/register?ref=798BI" target="_blank" rel="noopener noreferrer"
                class="btn btn-dark btn-large mb-2 py-3 px-4"><span class="h5">Ücretsiz denemeyi
                    başlat</span></a>
            <p><small>Herhangi bir ödeme yapmanız gerekmez.</small></p>
        </div>
    </div>
</section>



<footer class="footer-area py-5">
    <div class="container">
        <div class="row">
            <!-- Logo & Company Info -->
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="single-footer-widget">
                    <a href="#" (click)="scrollToTop()" onclick="return false" class="logo mb-3 d-inline-block">
                        <img src="assets/img/favdc.png" alt="dotcrea Logo" title="dotcrea Logo" class="footer_logo"
                            width="50" height="50">
                    </a>
                    <p class="footer-description">E-ticaret entegrasyonları ve Shopify çözümleri konusunda uzman
                        ekibimizle işinizi büyütün.</p>

                    <!-- Social Media Links -->
                    <div class="social-links mt-3">
                        <a href="https://www.linkedin.com/company/dotcrea" target="_blank" rel="noopener"
                            title="LinkedIn">
                            <i class='bx bxl-linkedin'></i>
                        </a>
                        <a href="https://x.com/dotcrea" target="_blank" rel="noopener" title="Twitter">
                            <i class='bx bxl-twitter'></i>
                        </a>
                        <a href="https://www.instagram.com/dotcrea" target="_blank" rel="noopener" title="Instagram">
                            <i class='bx bxl-instagram'></i>
                        </a>
                        <a href="https://www.facebook.com/dotcrea" target="_blank" rel="noopener" title="Facebook">
                            <i class='bx bxl-facebook'></i>
                        </a>
                        <a href="https://www.youtube.com/@dotcrea" target="_blank" rel="noopener" title="YouTube">
                            <i class='bx bxl-youtube'></i>
                        </a>
                    </div>
                </div>
            </div>

            <!-- Shopify Services -->
            <div class="col-lg-2 col-md-6 col-sm-6 mb-4 offset-lg-1">
                <div class="single-footer-widget">
                    <h5 class="footer-title">Shopify Hizmetleri</h5>
                    <ul class="footer-links-list">
                        <li><a [routerLink]="'shopify_store_setup' | route">Mağaza Kurulumu</a></li>
                        <li><a [routerLink]="'shopify_migration' | route">Shopify'a Geçiş</a></li>
                        <li><a [routerLink]="'shopify_theme_development' | route">Tema Geliştirme</a></li>
                        <li><a [routerLink]="'shopify_theme_customization' | route">Tema Özelleştirme</a></li>
                        <li><a [routerLink]="'shopify_app_development' | route">Uygulama Geliştirme</a></li>
                        <li><a [routerLink]="'shopify_maintenance' | route">Bakım ve Destek</a></li>
                    </ul>
                </div>
            </div>



            <!-- Integrations -->
            <div class="col-lg-2 col-md-6 col-sm-6 mb-4">
                <div class="single-footer-widget">
                    <h5 class="footer-title">Entegrasyonlar</h5>
                    <ul class="footer-links-list">
                        <li><a [routerLink]="'trendyol_integration' | route">Trendyol</a></li>
                        <li><a [routerLink]="'hepsiburada_integration' | route">Hepsiburada</a></li>
                        <li><a [routerLink]="'n11_integration' | route">N11</a></li>
                        <li><a [routerLink]="'amazon_integration' | route">Amazon</a></li>
                        <li><a [routerLink]="'parasut_integration' | route">Paraşüt</a></li>
                        <li><a [routerLink]="'aras_cargo' | route">Kargo Entegrasyonları</a></li>
                    </ul>
                </div>
            </div>

            <!-- Company & Resources -->
            <div class="col-lg-3 col-md-6 col-sm-6 mb-4">
                <div class="single-footer-widget">
                    <h5 class="footer-title">Kurumsal</h5>
                    <ul class="footer-links-list">
                        <li><a [routerLink]="'about' | route">Hakkımızda</a></li>

                        <li><a [routerLink]="'contact' | route">İletişim</a></li>

                        <li><a [routerLink]="'faq_page' | route">SSS</a></li>
                        <li><a [routerLink]="'pricing' | route">Fiyatlandırma</a></li>
                    </ul>
                </div>
            </div>

        </div>

        <hr class="footer-divider">

        <!-- Footer Bottom -->
        <div class="footer-bottom-area">
            <div class="row align-items-center">
                <div class="col-lg-4 col-md-12 mb-3 mb-lg-0">
                    <p class="copyright-text mb-0">&copy; 2024 dotCREA. Tüm hakları saklıdır.</p>
                </div>

                <div class="col-lg-4 col-md-12 mb-3 mb-lg-0 text-center">
                    <ul class="footer-bottom-links">
                        <li><a [routerLink]="'privacy' | route">Gizlilik Politikası</a></li>
                        <li><a [routerLink]="'user_agreement' | route">Kullanım Şartları</a></li>
                        <li><a [routerLink]="'cookie' | route">Çerez Politikası</a></li>
                    </ul>
                </div>

                <div class="col-lg-4 col-md-12 text-lg-end text-center">
                    <!-- <div class="language-switcher-wrapper">
                        <div class="language-dropdown" [class.open]="isLanguageDropdownOpen">
                            <button class="language-dropdown-toggle" (click)="toggleLanguageDropdown()">
                                <img [src]="'/assets/img/flag/' + currentLang + '.svg'"
                                    [alt]="currentLang === 'tr' ? 'Türkçe' : 'English'" width="24" height="24"
                                    class="flag-icon-small">
                                <span class="language-name">{{ currentLang === 'tr' ? 'Türkçe' : 'English' }}</span>
                                <i class='bx bx-chevron-down'></i>
                            </button>
                            <ul class="language-dropdown-menu" *ngIf="isLanguageDropdownOpen">
                                <li (click)="changeLanguage('tr')">
                                    <img src="/assets/img/flag/tr.svg" alt="Türkçe" width="24" height="24"
                                        class="flag-icon-small">
                                    <span>Türkçe</span>
                                </li>
                                <li (click)="changeLanguage('en')">
                                    <img src="/assets/img/flag/en.svg" alt="English" width="24" height="24"
                                        class="flag-icon-small">
                                    <span>English</span>
                                </li>
                            </ul>
                        </div>
                    </div> -->
                </div>

            </div>
        </div>
    </div>

</footer>